import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import Layout from "../../components/Layout"
import * as reportService from "../../utilities/services/report"

const InsightCard = ({ title, item }) => {
  return (
    <div className="card rounded-4 shadow-none h-100">
      <div className="card-body py-4">
        <div className="d-flex justify-content-between">
          <div>
            <p className="small text-body-tertiary fw-semibold m-0">{title}</p>
            <p className="small text-body-secondary fw-bold m-0">Top Product</p>
          </div>
          <p className="small text-theme text-end fw-bold m-0">{item?.title}</p>
        </div>
        <br />
        <br />
        <div className="d-flex justify-content-between align-items-center">
          <p className="lead text-body-emphasis fw-bold m-0">{item?.count}</p>
          <p className="lead text-body-emphasis fw-bold m-0">{item?.value && `Rs. ${item.value.toFixed(2)}`}</p>
        </div>
      </div>
    </div>
  )
}

const Insights = () => {
  const navigate = useNavigate()
  const { token } = useSelector(state => state.user)
  const [type, setType] = useState("daily")

  const [previousTopProduct, setPreviousTopProduct] = useState({})
  const [currentTopProduct, setCurrentTopProduct] = useState({})

  const [previousTopDeal, setPreviousTopDeal] = useState({})
  const [currentTopDeal, setCurrentTopDeal] = useState({})

  const getTopProduct = async () => {
    try {
      const previousQuery = new URLSearchParams({ by: "previous", type })
      const previousResponse = await reportService.getTopProduct(token, previousQuery.toString())
      if (!previousResponse.status) throw new Error(previousResponse.message)

      const currentQuery = new URLSearchParams({ by: "current", type })
      const currentResponse = await reportService.getTopProduct(token, currentQuery.toString())
      if (!currentResponse.status) throw new Error(currentResponse.message)

      setPreviousTopProduct(previousResponse.product)
      setCurrentTopProduct(currentResponse.product)
    } catch (error) {
      alert(error.message)
    }
  }

  const getTopDeal = async () => {
    try {
      const previousQuery = new URLSearchParams({ by: "previous", type })
      const previousResponse = await reportService.getTopDeal(token, previousQuery.toString())
      if (!previousResponse.status) throw new Error(previousResponse.message)

      const currentQuery = new URLSearchParams({ by: "current", type })
      const currentResponse = await reportService.getTopDeal(token, currentQuery.toString())
      if (!currentResponse.status) throw new Error(currentResponse.message)

      setPreviousTopDeal(previousResponse.deal)
      setCurrentTopDeal(currentResponse.deal)
    } catch (error) {
      alert(error.message)
    }
  }

  useEffect(() => {
  }, [])

  useEffect(() => {
    getTopProduct()
    getTopDeal()
  }, [type])

  let previousTitle = ""
  let currentTitle = ""
  switch (type) {
    case "daily":
      previousTitle = "Yesterday"
      currentTitle = "Today"
      break
    case "weekly":
      previousTitle = "Last Week"
      currentTitle = "This Week"
      break
    case "monthly":
      previousTitle = "Last Month"
      currentTitle = "This Month"
      break
    case "yearly":
      previousTitle = "Last Year"
      currentTitle = "This Year"
      break
    default:
      previousTitle = "Yesterday"
      currentTitle = "Today"
      break
  }

  return (
    <Layout
      header={true}
      footer={true}
    >
      <main className="py-3">
        <div className="container-fluid">
          <div className="row align-items-center mb-3">
            <div className="col-10">
              <p className="lead text-body-emphasis fw-bold m-0">Insights</p>
            </div>
            <div className="col-2">
              <select className="form-select rounded-4" onChange={(e) => setType(e.target.value)}>
                <option value="daily">Daily</option>
                {/* <option value="weekly">Weekly</option> */}
                <option value="monthly">Monthly</option>
                <option value="yearly">Yearly</option>
              </select>
            </div>
          </div>

          <div className="row gx-3">
            <div className="col-3">
              <InsightCard title={previousTitle} item={previousTopProduct} />
            </div>
            <div className="col-3">
              <InsightCard title={currentTitle} item={currentTopProduct} />
            </div>
            <div className="col-3">
              <InsightCard title={previousTitle} item={previousTopDeal} />
            </div>
            <div className="col-3">
              <InsightCard title={currentTitle} item={currentTopDeal} />
            </div>
          </div>
        </div>
      </main>
    </Layout>
  )
}

export default Insights